import React, { useEffect, useRef, useState } from "react";
import { COLORS, RADIUS, SHADOW } from "../../theme";

// Combobox com busca por nome — usado em todo campo que escolhe UM
// funcionário (ex: Novo Afastamento), pra não depender de rolar um <select>
// nativo gigante em tenants com 100+ funcionários.
export default function SeletorFuncionario({ funcionarios, value, onChange, placeholder = "Buscar funcionário..." }) {
  const [busca, setBusca] = useState("");
  const [aberto, setAberto] = useState(false);
  const containerRef = useRef(null);

  const selecionado = funcionarios.find((f) => String(f.id) === String(value));

  useEffect(() => {
    function aoClicarFora(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) setAberto(false);
    }
    document.addEventListener("mousedown", aoClicarFora);
    return () => document.removeEventListener("mousedown", aoClicarFora);
  }, []);

  const filtrados = funcionarios.filter((f) => f.nome.toLowerCase().includes(busca.toLowerCase()));

  return (
    <div ref={containerRef} style={{ position: "relative" }}>
      <input
        value={aberto ? busca : (selecionado?.nome || "")}
        onChange={(e) => { setBusca(e.target.value); setAberto(true); }}
        onFocus={() => { setBusca(""); setAberto(true); }}
        placeholder={placeholder}
        style={{
          width: "100%", boxSizing: "border-box", border: `1.5px solid ${COLORS.border}`, borderRadius: RADIUS.md,
          padding: "11px 14px", fontSize: 14, background: COLORS.bg, color: COLORS.text, outline: "none",
        }}
      />
      {aberto && (
        <div
          style={{
            position: "absolute", top: "100%", left: 0, right: 0, marginTop: 4, background: COLORS.surface,
            border: `1.5px solid ${COLORS.border}`, borderRadius: RADIUS.md, boxShadow: SHADOW.raised,
            maxHeight: 240, overflowY: "auto", zIndex: 30,
          }}
        >
          {filtrados.length === 0 ? (
            <div style={{ padding: "10px 14px", fontSize: 13, color: COLORS.textLight }}>Nenhum funcionário encontrado.</div>
          ) : (
            filtrados.map((f) => (
              <button
                key={f.id}
                type="button"
                onClick={() => { onChange(f.id); setBusca(""); setAberto(false); }}
                style={{
                  display: "block", width: "100%", textAlign: "left", padding: "9px 14px", fontSize: 13.5,
                  color: COLORS.text, background: String(f.id) === String(value) ? COLORS.primaryBg : "transparent",
                  border: "none", cursor: "pointer",
                }}
              >
                {f.nome}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
